import Notification from "./notification/Notification.svelte";
import Settings from "./settings/Settings.svelte";
import New from "./new/New.svelte";
import Analytics from "./analytics/Analytics.svelte";
import Support from "./support/Support.svelte";
import "bulma/css/bulma.css";
import "bulma-tooltip";
import "./app.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import {
  PHP
} from "./store";
import initCustomFormatter from "./utils/customFormatter";
import Alert from './globals/Alert.svelte';
import Introduction from './globals/Introduction.svelte';
import Upgrade from './globals/Upgrade.svelte';
import {
  showSubscribePrompt
} from "./utils/showSubscribePrompt";

// Create a custom validation function fo validate.js
initCustomFormatter();
const parsed_php_data = JSON.parse(php_data);
PHP.set(parsed_php_data);

const alertWrapper = document.getElementById('bp-alert');
const introductionWrapper = document.getElementById('bp-introduction');
const upgradeWrapper = document.getElementById('bp-upgrade');

const notificationWrapper = document.getElementById("best_push_notifications");
const newWrapper = document.getElementById("best_push_new");
const settingsWrapper = document.getElementById("best_push_settings");
const analyticsWrapper = document.getElementById("best_push_analytics");
const supportWrapper = document.getElementById("best_push_support");
const title = document.getElementById("title");

new Alert({
  target: alertWrapper,
});

new Introduction({
  target: introductionWrapper,
});

new Upgrade({
  target: upgradeWrapper,
});

if (notificationWrapper) {
  title.innerText = 'Notifications';
  new Notification({
    target: notificationWrapper
  });
}

if (newWrapper) {
  title.innerText = 'New Message';
  new New({
    target: newWrapper
  });
}

if (settingsWrapper) {
  title.innerText = 'Settings';
  new Settings({
    target: settingsWrapper
  });
}

if (analyticsWrapper) {
  title.innerText = 'Analytics';
  new Analytics({
    target: analyticsWrapper
  });
}

if (supportWrapper) {
  title.innerText = 'Support';
  new Support({
    target: supportWrapper
  });
}

if (parsed_php_data.isActivated) {
  showSubscribePrompt(parsed_php_data.app_id, {
    dialogRetryRate: 3600,
  });
}